import { computed, ref } from 'vue'
import type { Ref } from 'vue'

import type { Match, MatchID } from '@/types/app'

type Args = {
  matches: Ref<readonly Match[] | undefined>
  selectedMatchId: Ref<MatchID | undefined>
}

export const useMatchList = (args: Args) => {
  const checkedMatchIds = ref<MatchID[]>([])

  const selectorList = computed(
    () =>
      args.matches.value?.map(match => ({
        match,
        checked: checkedMatchIds.value.includes(match.id),
      })) ?? []
  )

  // NOTE: unwrap selectorList
  const matchList = computed(() => selectorList.value.map(({ match }) => match))

  const checkMatch = (matchId: MatchID, checked: boolean) => {
    if (checked) {
      checkedMatchIds.value = uniq([...checkedMatchIds.value, matchId])
    } else {
      checkedMatchIds.value = checkedMatchIds.value.filter(id => id !== matchId)
    }
  }

  const changeBulkChecked = (checked: boolean) => {
    if (checked) {
      checkedMatchIds.value = args.matches.value?.map(match => match.id) ?? []
    } else {
      checkedMatchIds.value = []
    }
  }

  return {
    selectorList,
    matchList,
    checkMatch,
    changeBulkChecked,
  }
}

function uniq<T>(array: T[]): T[] {
  return Array.from(new Set(array))
}
